<template>
  <IndexBase
    @auth="onAuth($event)"
    action="Index"
    controller="Approval"
  ></IndexBase>

  <OverlayPanel
    ref="op"
    :showCloseIcon="true"
    :dismissable="true"
    :breakpoints="{ '960px': '75vw', '640px': '100vw' }"
    :style="{ width: '450px' }"
  >
    <InputText
      v-model="overlayText"
      @input="onEditRemarks"
      style="width: 100%"
    />
  </OverlayPanel>

  <Dialog
    :header="$t('approval_confirmation')"
    v-model:visible="showApprovalConfirmationModal"
    :closeOnEscape="false"
    :closable="false"
    :modal="true"
    :breakpoints="{ '960px': '75vw', '640px': '100vw' }"
    :style="{ width: '50vw' }"
  >
    <div>
      {{ this.$t("message.approval_confirmation") + confirmationStatus }}
      <!-- 
            <ul v-for="(doc) in selectedDocuments" v-bind:key="doc.id">
               <li>{{doc.ref_no}}</li> 
            </ul> -->

      <div>
        <div v-for="doc in approvalData" v-bind:key="doc.ref_no">
          <div class="grid">
            <div class="col-3">
              {{ doc.ref_no }}
            </div>
            <div class="col-5">
              <div class="p-fluid">
                <InputText
                  type="text"
                  :class="[
                    invalid && (doc.remarks == '' || doc.remarks == null)
                      ? 'p-invalid'
                      : '',
                    'p-inputtext-sm',
                  ]"
                  v-model="doc.remarks"
                />
                <small
                  v-if="invalid && (doc.remarks == '' || doc.remarks == null)"
                  style="color: red"
                  >{{ $t("alert.require_remarks") }}</small
                >
              </div>
            </div>
            <div class="col-3">
              <div v-if="!doc.processed">
                <div v-if="doc.processing">
                  <ProgressSpinner style="width: 30px; height: 30px;float:left" />
                </div>
              </div>
              <div v-else>
                <div v-if="doc.status">
                  <Tag
                    class="mr-2"
                    :severity="
                      confirmationStatus == $APPROVAL_STATUS.APPROVED
                        ? 'success'
                        : 'danger'
                    "
                    :value="
                      confirmationStatus == $APPROVAL_STATUS.APPROVED
                        ? 'Approved'
                        : 'Rejected'
                    "
                  >
                  </Tag>
                </div>
                <div v-else>
                  <Tag class="mr-2" severity="danger" :value="doc.result"></Tag>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- <div v-else>
        <div v-for="item in resultData" v-bind:key="item.ref_no">
          <div class="grid">
            <div class="col-5">
              {{ item.ref_no }}
            </div>
            <div class="col-6">
              <div class="p-fluid">
                <InputText
                  type="text"
                  class="p-inputtext-sm"
                  v-model="item.remarks"
                  :disabled="true"
                />
              </div>
            </div>
            <div class="col-1">
              <div v-if="item.success">
                <Tag
                  class="mr-2"
                  :severity="
                    confirmationStatus == $APPROVAL_STATUS.APPROVED
                      ? 'success'
                      : 'danger'
                  "
                  :value="
                    confirmationStatus == $APPROVAL_STATUS.APPROVED
                      ? 'Approved'
                      : 'Rejected'
                  "
                >
                </Tag>
              </div>
              <div v-else>
                <Tag class="mr-2" severity="danger" :value="item.message"></Tag>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>

    <template #footer>
      <div v-if="processed">
        <Button label="Close" @click="dismissConfirmation" />
      </div>
      <div v-else>
        <div v-if="processing" style="float: right !important">
          <ProgressSpinner style="width: 50px; height: 50px" />
        </div>
        <div v-else>
          <div v-if="!processed">
            <Button label="No" @click="dismissConfirmation" />
            <Button
              label="Yes"
              autofocus
              @click="confirmApproval"
              class="pi-button p-button-success"
            />
          </div>
          <div v-else>
            <Button
              label="Close"
              icon="pi pi-times"
              class="p-button-text"
              @click="onClose"
            />
          </div>
        </div>
      </div>
    </template>
  </Dialog>

  <Dialog
    header="Approval Details"
    v-model:visible="showApprovalDetails"
    :closeOnEscape="true"
    :closable="true"
    :modal="true"
    :breakpoints="{ '960px': '75vw', '640px': '100vw' }"
    :style="{ width: '60vw' }"
  >
    <DataTable
      :loading="!approvalDetails"
      :value="approvalDetails ? approvalDetails : null"
      responsiveLayout="scroll"
      class="p-datatable-sm editable-cells-table"
      :rowClass="setCurrentRow"
    >
      <Column
        field="ApprovalAs"
        :header="$t('role')"
        key="ApprovalAs"
        style="width: 10%"
      >
      </Column>
      <Column
        field="Username"
        :header="$t('username')"
        key="Username"
        style="width: 10%"
      >
      </Column>
      <Column
        field="fullname"
        :header="$t('full_name')"
        key="Fullname"
        style="width: 10%"
      >
      </Column>
      <Column
        field="Level"
        :header="$t('level')"
        key="Level"
        style="width: 10%"
      >
      </Column>
      <Column field="Status" :header="$t('status')" key="Status"> </Column>
      <Column
        field="ApprovalBy"
        :header="$t('approval_by')"
        key="ApprovalBy"
        style="width: 15%"
      >
      </Column>
      <Column
        field="ApprovalDate"
        :header="$t('approval_date')"
        key="ApprovalDate"
        style="width: 15%"
      >
        <template #body="{ data }">
          {{ this.$formatDateTime(data.ApprovalDate) }}
        </template>
      </Column>
      <Column
        field="Info1"
        :header="$t('matrix')"
        key="Info1"
        style="width: 10%"
      >
      </Column>
      <Column
        field="Info2"
        :header="$t('validity')"
        key="Info2"
        style="width: 15%"
      >
      </Column>
    </DataTable>
  </Dialog>

  <Card>
    <template #title>
      <Toolbar>
        <template #left>
          <div class="p-card-title">
            Approval

            <Button
              icon="pi pi-refresh"
              class="p-button-rounded p-button-info p-button-outlined ml-2"
              @click="loadLazyData"
            />
          </div>
        </template>

        <template #right>
          <Button
            class="pi-button p-button-success"
            :label="$t('approve')"
            v-if="selectedRow != null && selectedRow.length > 0"
            @click="processSelectedData($APPROVAL_STATUS.APPROVED)"
          />
          <Button
            class="pi-button p-button-danger ml-2"
            :label="$t('reject')"
            v-if="selectedRow != null && selectedRow.length > 0"
            @click="processSelectedData($APPROVAL_STATUS.REJECTED)"
          />
        </template>
      </Toolbar>
    </template>
    <template #content>
      <div class="p-fluid mb-3">
        <CustomSelectButton
          v-model="selectedStatus"
          :options="statusList"
          optionLabel="option"
          class="p-text-center"
          @change="onStatusChange"
          :setDefault="true"
        >
          <template #option="slotProps">
            <div class="p-text-center" style="width: 100%">
              {{ slotProps.option }}
            </div>
          </template>
        </CustomSelectButton>
      </div>

      <DataTable
        ref="dt"
        responsiveLayout="scroll"
        class="p-datatable-sm"
        filterDisplay="row"
        sortMode="multiple"
        removableSort
        stateStorage="local"
        :stateKey="stateKey"
        :value="dataModel"
        :loading="!dataModel || loading"
        :paginator="true"
        :rows="pageSize"
        :lazy="true"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 50]"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        v-model:first="this.start"
        @state-restore="onStateRestore($event)"
        @state-save="onStateSave($event)"
        @page="onPage($event)"
        @sort="onSort($event)"
        @filter="onFilter($event)"
        @update:selection="onSelect($event)"
        @row-dblclick="onRowDoubleClick"
        v-model:filters="filters"
        :totalRecords="totalRecords"
        v-model:selection="selectedRow"
        selectionMode="multiple"
        dataKey="Id"
        :metaKeySelection="false"
      >
        <Column :exportable="false" :sortable="false" headerStyle="width: 1rem">
          <template #header="">
            <!-- <Button v-if="canCreate" label="Create" icon="pi pi-plus" class="p-button-primary p-button-sm" @click="editor(this.$FORM_MODE_CREATE, 0)" /> -->
          </template>
          <template #filter>
            <Button
              :label="$t('clear')"
              icon="pi pi-filter-slash"
              class="p-button-outlined p-button-primary p-button-sm"
              @click="clearFilter"
              :badge="filterBadge"
              badgeClass="p-badge-danger"
            />
          </template>
          <!-- <template #body="{data}">
                        <button class="p-row-toggler p-link ml-2" type="button" v-ripple @click="toggleRemarksPopup($event,data)" v-tooltip.right="{value: data.Remarks, disabled: !data.Remarks}">
                            <i class="pi pi-comment p-text-secondary" v-badge="Y" v-if="data.Remarks"></i>
                            <i class="pi pi-comment p-text-secondary" v-else></i>
                        </button>                        
                    </template> -->
        </Column>
        <Column key="Id">
          <template #filter>
            <Checkbox
              v-model="this.isSelectAll"
              @change="SelectAll()"
              :binary="true"
            />
          </template>
        </Column>
        <Column
          v-if="permit"
          field="Permit_Date"
          :header="$t('date')"
          dataType="date"
          :sortable="true"
        >
          <template #filter="{ filterModel, filterCallback }">
            <Calendar
              momentFormat="DD/MM/YYYY"
              class="p-column-filter p-inputtext-sm"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              :placeholder="$t('date')"
              @date-select="filterCallback()"
            />
          </template>
          <template #body="{ data }">
            {{ this.$formatDate(data.Permit_Date) }}
          </template>
        </Column>
        <Column
          v-if="permit"
          field="Permit_Number"
          :header="$t('permit_number')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('permit_number')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
          <template #body="slotProps">
            <!-- <a :href="'Permit/Editor?mode=View&id=' + data.Id" target="_blank">{{ data.Permit_Number }}
                        </a> -->
            <Button
              :label="slotProps.data.Permit_Number"
              class="p-button-text"
              @click="goToDetail(slotProps)"
            />
          </template>
        </Column>
        <Column
          v-if="permit"
          field="Permit_Status"
          :header="$t('status')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('status')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          v-if="permit"
          field="Permit_Critical"
          :header="$t('criticality')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('criticality')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          v-if="permit || work"
          field="Type"
          :header="$t('type')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('type')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          v-if="permit"
          field="Permit_Vendor"
          :header="$t('vendor')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('vendor')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          v-if="permit"
          field="Permit_Company"
          :header="$t('company')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('company')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          v-if="permit"
          field="Permit_Category"
          :header="$t('permit_category')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('permit_category')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          v-if="permit"
          field="Permit_User"
          :header="$t('permit_user')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('permit_user')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          v-if="permit"
          field="Permit_Area"
          :header="$t('permit_area')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('permit_area')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          v-if="permit"
          field="Permit_Title"
          :header="$t('permit_title')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('permit_title')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          v-if="permit"
          field="Permit_Role"
          :header="$t('permit_role')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('permit_role')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          v-if="work"
          field="Date_Open"
          :header="$t('date')"
          dataType="date"
          :sortable="true"
        >
          <template #filter="{ filterModel, filterCallback }">
            <Calendar
              momentFormat="DD/MM/YYYY"
              class="p-column-filter p-inputtext-sm"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              :placeholder="$t('date')"
              @date-select="filterCallback()"
            />
          </template>
          <template #body="{ data }">
            {{ this.$formatDate(data.Date_Open) }}
          </template>
        </Column>
        <Column
          v-if="work"
          field="Work_Number"
          :header="$t('work_number')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('work_number')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
          <template #body="slotProps">
            <!-- <a :href="'Permit/Editor?mode=View&id=' + data.Id" target="_blank">{{ data.Permit_Number }}
                        </a> -->
            <Button
              :label="slotProps.data.Work_Number"
              class="p-button-text"
              @click="goToDetail(slotProps)"
            />
          </template>
        </Column>
        <Column
          v-if="work"
          field="Work_Role"
          :header="$t('work_role')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('work_role')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          v-if="work"
          field="Work_Vendor"
          :header="$t('work_vendor')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('work_vendor')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          v-if="work"
          field="Work_Company"
          :header="$t('work_company')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('work_company')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          v-if="work"
          field="Work_Status"
          :header="$t('work_status')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('work_status')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          v-if="work"
          field="Work_Area"
          :header="$t('work_area')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('work_area')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          v-if="work"
          field="Work_Title"
          :header="$t('work_title')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('work_title')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          v-if="pendingpriv || pendinguser"
          field="UsernameUserReq"
          :header="$t('username')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('username')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          v-if="pendingpriv"
          field="UserFullName"
          :header="$t('fullname')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('fullname')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          v-if="pendingpriv || pendinguser"
          field="UserEmail"
          :header="$t('email')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('email')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          v-if="pendingpriv || linkedcompany || suspension"
          field="Company_Country"
          :header="$t('company_country')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('company_country')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          v-if="pendingpriv || linkedcompany || suspension || pendinguser"
          field="Company_Type"
          :header="$t('company_type')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('company_type')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          field="Company_Code"
          :header="$t('companycode')"
          :sortable="true"
          v-if="pendingpriv || linkedcompany || pendinguser"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('companycode')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          field="Company_Name"
          :header="$t('companyname')"
          :sortable="true"
          v-if="pendingpriv || linkedcompany || suspension || pendinguser"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('companyname')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          field="Company_Location"
          :header="$t('location')"
          :sortable="true"
          v-if="linkedcompany"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('location')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          field="Company_Description"
          :header="$t('description')"
          :sortable="true"
          v-if="linkedcompany"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('description')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          v-if="pendingpriv"
          field="Depart_Code"
          :header="$t('departcode')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('departcode')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          v-if="pendingpriv"
          field="Depart_Name"
          :header="$t('departname')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('departname')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>

        <Column
          v-if="suspension"
          field="Suspend_Remark"
          :header="$t('reason')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('reason')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <Column
          v-if="pendinguser"
          field="CompanyPend_Type"
          :header="$t('pending_type')"
          :sortable="true"
        >
          <!--<Column field="Code" header="Code" :sortable="true" style="flex-grow:1; flex-basis:100px">-->
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              :placeholder="$t('pending_type')"
              type="text"
              v-if="filterModel"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter p-inputtext-sm"
            />
          </template>
        </Column>
        <!--   <template #expansion="slotProps">
                    <div class="orders-subtable">
                        <DataTable :value="slotProps.data.Details" class="w-screen-70" v-if="suspension">
                            <Column field="Dept_Code" :header="$t('code')" />
                            <Column field="Dept_Name" :header="$t('name')" />
                        </DataTable>
                    </div>
                </template>-->
      </DataTable>
    </template>
  </Card>
</template>

<script>
export default {
  name: "Approval",
  data() {
    return {
      dataModel: null,
      loading: false,
      totalRecords: 0,
      start: 0,
      stateKey: "weptw-state-approval-" + this.$store.getters.getUsername,
      role: this.$store.getters.getRole,
      isAdmin: this.$store.getters.getIsAdmin,
      isUser: this.$store.getters.getIsUser,
      sorts: null,
      lazyParams: {},
      filters: null,
      stateFilters: null,
      editorPath: "/Approval/Editor",
      approvalDetailsUrl: "approval/approval_details/",
      dataUrl: "approval/list",
      statusUrl: "approval/status",
      approveUrl: "approval/process",
      canCreate: false,
      canEdit: false,
      canDelete: false,
      canView: false,
      selectedRow: null,
      statusList: null,
      selectedStatus: null,
      expandedRows: [],
      pageSize: 10,
      category: "",
      selectedCategoryIndex: 0,
      overlayData: null,
      overlayText: "",
      showApprovalConfirmationModal: false,
      confirmationStatus: "",
      processed: false,
      processing: false,
      resultData: [],
      invalid: false,
      isSelectAll: false,
      dataModel1: null,

      showApprovalDetails: false,
      approvalDetails: [],

      approvalData: [],
    };
  },
  methods: {
    onEditRemarks() {
      this.overlayData.Remarks = this.overlayText;
    },
    toggleRemarksPopup(event, data) {
      this.overlayData = data;
      this.overlayText = data.Remarks;
      this.$refs.op.toggle(event);
    },
    onAuth(event) {
      this.canCreate = event.canCreate;
      this.canEdit = event.canEdit;
      this.canDelete = event.canDelete;
      this.canView = event.canView;
    },
    onPage(event) {
      this.pageSize = event.rows;
      this.start = event.first;
      this.loadLazyData();
    },
    onSort(event) {
      this.sorts = event.multiSortMeta;
      this.loadLazyData();
    },
    onFilter() {
      this.loadLazyData();
    },
    onSelect(event) {
      this.selectedRow = event.data;
      //console.log(event.data)
    },
    onRowExpand(event) {
      this.expandedRows = [];
      this.expandedRows.push(event.data);
    },
    editor(mode, id) {
      this.$router.push({
        path: this.editorPath,
        query: { mode: mode, id: id },
      });
    },
    loadLazyData() {
      this.selectedRow = null;
      this.isSelectAll = false;
      this.lazyParams = {
        start: this.start,
        pageSize: this.pageSize,
        sorts: this.dataSort,
        filters: this.dataFilter,
        category: this.selectedStatus,
      };

      var self = this;

      if (!self.loading) {
        this.loading = true;

        this.$axios
          .post(this.$API_URL + this.dataUrl, this.lazyParams)
          .then((response) => {
            if (response.data.success) {
              self.dataModel = response.data.data;
              self.dataModel1 = response.data.data;
              self.totalRecords = response.data.totalRecords;
              //console.log(self.dataModel)
            } else {
              self.$toast.add({
                severity: "error",
                summary: "Error",
                detail: response.data.message,
                life: 3000,
              });
            }

            self.loading = false;
          })
          .catch(function (err) {
            self.$toast.add({
              severity: "error",
              summary: "Error",
              detail: err.message,
              life: 3000,
            });
            self.loading = false;
          });
      }
    },
    setFilters() {
      this.filters = {};
      var exportable = this.$refs.dt.columns.filter((c) => c.props.field);
      for (var i = 0; i < exportable.length; i++) {
        var filterValue = "";
        if (this.stateFilters) {
          var field = this.stateFilters[exportable[i].props.field];
          if (field) filterValue = field.value;
        }
        this.filters[exportable[i].props.field] = {
          value: filterValue,
          matchMode: "contains",
        };
      }
    },
    onStateRestore(event) {
      this.start = event.first;
      this.pageSize = event.rows;
      this.stateFilters = event.filters;
      this.sorts = event.multiSortMeta;

      this.selectedCategoryIndex = event.selectedCategoryIndex ?? 0;
    },
    onStateSave(event) {
      event.selectedCategoryIndex = this.selectedCategoryIndex;
    },
    onModalClose() {
      this.loadLazyData();
    },
    clearFilter() {
      this.filters = {};
      var exportable = this.$refs.dt.columns.filter((c) => c.props.field);
      for (var i = 0; i < exportable.length; i++) {
        this.filters[exportable[i].props.field] = {
          value: "",
          matchMode: "contains",
        };
      }
      this.loadLazyData();
    },
    onStatusChange(event) {
      this.selectedStatus = event.value;
      this.selectedCategoryIndex = event.index;
      this.$refs.dt.triggerSaveState();
      this.setFilters();
      this.$toast.removeAllGroups();
      this.loadLazyData();
    },
    processSelectedData(status) {
      var dataApproval = [];
      for(var x = 0; x<this.selectedDocuments.length;x++){
        var dd = {... this.selectedDocuments[x]};

        dataApproval.push(dd);
      }

      this.approvalData = dataApproval;

      this.showApprovalConfirmationModal = true;
      this.confirmationStatus = status;
    },
    async confirmApproval() {
      var self = this;

      self.invalid = false;

      // if (self.checkRemarks())
      //     return;
      if (self.confirmationStatus != self.$APPROVAL_STATUS.APPROVED) {
        for (var i = 0; i < self.approvalData.length; i++) {
          if (
            self.approvalData[i].remarks == undefined ||
            !self.approvalData[i].remarks
          ) {
            self.invalid = true;
            result = true;
            break;
          }
        }
      }

      for(var x = 0; x< self.approvalData.length;x++)
      {
        var doc = self.approvalData[x];

        var data = {
           data: doc,
          status: self.confirmationStatus,
        }

        self.processing = true;

        doc.processing = true;

       await self.$axios
        .put(self.$API_URL + self.approveUrl, data)
        .then((response) => {
          //self.processed = true;
            
            doc.processing = false;
            
            doc.processed = true;
            doc.status = response.data.success;
            doc.result = response.data.message;

          if (response.data.success) {
            //self.resultData = response.data.data.data;


            //   self.$router.push({
            //     name: this.indexName,
            //     params: {
            //       showToast: true,
            //       severity: "success",
            //       summary: "Data Saved",
            //       detail: response.data.message,
            //       life: 3000,
            //     },
            //   });
            // } else {
            //   self.$toast.add({
            //     severity: "error",
            //     summary: "Error",
            //     detail: response.data.message,
            //     life: 3000,
            //   });

            // doc.status = false;
            // doc.result = response.data.message;
          }
        })
        .catch(function (error) {
          // self.processed = false;
          // self.processing = false;

          // self.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: error,
          //   life: 3000,
          // });

          doc.status = false;
          doc.result = error;
        });
      }
      self.processed = true;
      
          self.processing = false;

      // var data = {
      //   data: this.selectedDocuments,
      //   status: this.confirmationStatus,
      // };

      
    },
    dismissConfirmation() {
      this.processed = false;
      this.invalid = false;
      this.showApprovalConfirmationModal = false;
      this.loadLazyData();
    },
    onRowDoubleClick(event) {
      var self = this;
      self.approvalDetails = [];
      var approvalDataId = event.data.ApprovalId;
      var dataId = event.data.Id;

      self.showApprovalDetails = true;

      this.$axios
        .get(
          this.$API_URL +
            this.approvalDetailsUrl +
            dataId +
            "/" +
            approvalDataId
        )
        .then((response) => {
          if (response.data.success) {
            self.approvalDetails = response.data.data;
            self.$router.push({
              name: this.indexName,
              params: {
                showToast: true,
                severity: "success",
                summary: "Data Saved",
                detail: response.data.message,
                life: 3000,
              },
            });
          } else {
            self.showApprovalDetails = false;
            self.$toast.add({
              severity: "error",
              summary: "Error",
              detail: response.data.message,
              life: 3000,
            });
          }
        })
        .catch(function (error) {
          self.showApprovalDetails = false;

          self.$toast.add({
            severity: "error",
            summary: "Error",
            detail: error,
            life: 3000,
          });
        });
    },
    setCurrentRow(data) {
      //console.log(data);
      return data.is_current ? "current-approval" : "";
    },
    checkRemarks() {
      var result = false;

      var self = this;
      self.invalid = false;

      if (!this.selectedStatus.toLowerCase().includes("appointment")) {
        return false;
      }

      if (this.confirmationStatus == this.$APPROVAL_STATUS.APPROVED) {
        return false;
      }

      for (var x = 0; x < this.selectedRow.length; x++) {
        var doc = this.selectedRow[x];

        if (
          (doc.Remarks == "" || doc.Remarks == null || !doc.Remarks) &&
          this.confirmationStatus != this.$APPROVAL_STATUS.APPROVED
        ) {
          self.invalid = true;
          result = true;
          break;
        }
      }

      return result;
    },
    goToDetail(event) {
      var index = event.index;
      var data = event.data;

      if (this.permit) {
        let routeData = this.$router.resolve({
          name: "PermitEditor",
          query: { mode: this.$FORM_MODE_VIEW, id: data.PermitId },
        });
        window.open(routeData.href, "_blank");
      } else if (this.work) {
        let routeData = this.$router.resolve({
          name: "WorkEditor",
          query: { mode: this.$FORM_MODE_VIEW, id: data.WorkId },
        });
        window.open(routeData.href, "_blank");
      }
    },
    SelectAll() {
      if (this.isSelectAll) {
        this.selectedRow = this.dataModel1;
      } else {
        this.selectedRow = null;
      }
    },
  },
  mounted() {
    this.$emit("unblock-ui");
    this.setFilters();

    var self = this;

    this.$axios
      .get(this.$API_URL + this.statusUrl)
      .then((response) => {
        if (response.data.success) {
          self.statusList = response.data.data;
          var selectedStatusValue = Object.values(this.statusList)[
            this.selectedCategoryIndex
          ];
          if (selectedStatusValue == undefined) {
            self.selectedStatus = Object.values(this.statusList)[0];
          } else {
            self.selectedStatus = selectedStatusValue;
          }

          self.loadLazyData();
        } else {
          self.$toast.add({
            severity: "error",
            summary: "Error",
            detail: response.data.message,
            life: 3000,
          });
        }

        self.loading = false;
      })
      .catch(function (err) {
        //console.log(self);
        self.$toast.add({
          severity: "error",
          summary: "Error",
          detail: err,
          life: 3000,
        });
        self.loading = false;
      });
  },
  computed: {
    dataFilter() {
      var h = [];
      if (this.filters) {
        for (const [key, value] of Object.entries(this.filters)) {
          h.push({
            field: key,
            value: value.value,
            matchMode: value.matchMode,
          });
        }
      }
      return h;
    },
    dataSort() {
      var h = [];
      if (this.sorts) {
        for (var x = 0; x < this.sorts.length; x++) {
          h.push({
            field: this.sorts[x].field,
            order: this.sorts[x].order == 1 ? "ASC" : "DESC",
          });
        }
      }
      return h;
    },
    work() {
      return this.selectedCategoryIndex == 0;
    },
    permit() {
      return this.selectedCategoryIndex == 1;
    },
    linkedcompany() {
      return this.selectedCategoryIndex == 2;
    },
    suspension() {
      return this.selectedCategoryIndex == 3;
    },
    pendingpriv() {
      return this.selectedCategoryIndex == 4;
    },
    pendinguser() {
      return this.selectedCategoryIndex == 5;
    },
    selectedDocuments() {
      var data = [];
      if (this.selectedRow == null) return data;

      for (var x = 0; x < this.selectedRow.length; x++) {
        var row = this.selectedRow[x];
        var d = {
          id: row.Id,
          remarks: row.Remarks,
          ref_no: row.ReferenceNo,
          processing: false,
          processed: false,
          result: "",
          status: false
        };

        data.push(d);
      }

      return data;
    },
    filterBadge() {
      var badgeNumber = 0;

      this.dataFilter.filter(function (item) {
        if (item.value && item.field != "Status") {
          badgeNumber++;
        }
      });

      return badgeNumber;
    },
  },
};
</script>

<style #scoped>
.p-card .p-card-content {
  margin: 0 !important;
  padding: 0 !important;
}
</style>
